<template>
  <div id="app" :class="$route.path === '/setup' ? '' : 'white'">
    <header :class="scrolled ? 'over' : ''">
			<nav class="nav">
				<img src="@/assets/imgs/logo.png"/>
        <span class="setup-title" v-if="$route.path === '/setup'">信易达超算配置系统</span>
				<ul class="ul">
					<li>
						<a href="#/" :class="$route.path === '/' ? 'active' : ''">首页</a>
					</li>
					<li>
						<a href="#/store" :class="$route.path === '/store' ? 'active' : ''">高性能存储</a>
					</li>
					<li>
						<a href="#/software" :class="$route.path === '/software' ? 'active' : ''">超算运维管理软件</a>
					</li>
					<li>
						<a href="#/about" :class="$route.path === '/about' ? 'active' : ''">关于我们</a>
					</li>
					<li v-if="loginName">
						<a href="#/setup" :class="$route.path === '/setup' ? 'active' : ''">超算配置系统</a>
					</li>
					<li>
						<el-button v-show="!loginName" size="small" @click="dialogVisible = true">登录</el-button>
            <el-dropdown v-show="loginName" class="user-btn">
              <el-button size="small">
                <i class="el-icon-user-solid"></i>{{loginName}}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="logout">注销</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
						
					</li>
				</ul>
			</nav>
    </header>
    <el-dialog
      title="登录"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <el-form :model="form">
        <el-form-item label="用户名" label-width="120px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="120px">
          <el-input v-model="form.pwd" type="password" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="login">确 定</el-button>
      </div>
    </el-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import store from './store.js'
import axios from 'axios'
export default {
  name: 'app',
  data () {
    return {
      count: 0,
      fnScroll: () => {},
      scrolled: false,
      dialogVisible: false,
      loginName: false,
      form: {
        name: '',
        pwd: ''
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.fnThrottle(this.fnHandleScroll, 200), false)
    console.log('this.$route.path', this.$route.path)

    this.loginName = localStorage.getItem('loginXYDName');

    if (this.$route.path == '/setup' && !this.loginName) {
      this.$router.push('/')
    }
  },
  methods: {
    /**
     * @description [fnHandleScroll 内容区域滚动]
     * @author   shanshuizinong
     * @param    {Object}   e [事件对象]
     * @returns   {null}    [没有返回]
     */
    fnHandleScroll (e) {
      this.scrolled = window.scrollY > 50
      store.setScrollAction(window.scrollY)
    },
    /**
     * @description [fnThrottle 节流函数]
     * @author shanshuizinong
     * @param {Function} fn 延时调用函数
     * @param {Number} delay 延迟多长时间
     * @param {Number} atleast 至少多长时间触发一次
     * @return {Function} 延迟执行的方法
     */
    fnThrottle (fn, delay, atleast) {
      let timer = null
      let previous = null
      return function () {
        let now = +new Date()
        if (!previous) previous = now
        if (atleast && now - previous > atleast) {
          fn()
          previous = now
          clearTimeout(timer)
        } else {
          clearTimeout(timer)
          timer = setTimeout(function () {
            fn()
            previous = null
          }, delay)
        }
      }
    },
    // 登录
    login() {
      var me = this
      axios.post('http://form.mixwechat.com/api/interface/info/hasdata/', {
        nx_formid: '60d594bb4c92a54a760b7e6c',
        name: this.form.name,
        pwd: this.form.pwd
      })
      .then(function (response) {
        response = response.data
        if (response.code == 200 && response.data * 1 > 0) {
          me.dialogVisible = false
          me.loginName = me.form.name
          localStorage.setItem('loginXYDName', me.loginName)
          me.$message({
            message: '登录成功',
            type: 'success'
          });
        } else {
          me.$message.error('用户名或密码错误');
        }
      })
      .catch(function (error) {
        me.$message.error('服务器出错，请稍后再试');
      });
    },
    // 登出
    logout() {
      localStorage.setItem('loginXYDName', '')
      this.loginName = ''
      this.$message({
        message: '已登出',
        type: 'success'
      });
      if (this.$route.path == '/setup') {
        this.$router.push('/')
      }
    }
  },
  watch: {
    $route(nP, oP) {
      console.log('nP oP: ', nP, oP)
      if (nP.path == '/setup' && !this.loginName) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="less" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1200px;
  overflow: auto;
  &.white {
    .ul {
      li a {
        color: #fff;
      }
      a:hover, a.active {
        border-bottom: 2.5px solid #fff;
        color: #fff;
        padding-bottom:5% ;
      }
    }
    header.over {
      background: rgba(0, 107, 191, .88);
    }
    .nav img {
      background: rgba(255, 255, 255, .8);
      padding: 5px 8px;
      border-radius: 5px;
      position: relative;
      left: -3px;
      top: -3px;
    }
  }
}

header {
  top: 0;
  position: fixed;
  width: 100%;
  margin: 0;
  height: 56px;
  color: #ffffff;
  transition: all .2s;
  z-index: 10000;
  &.over {
    background: rgba(255, 255, 255, .9);
    box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
  }
}

nav {
  background-size: 100% 100%;
  padding: 12px 0;
  vertical-align: middle;
  .setup-title {
    color: #000;
    font-size: 18px;
    line-height: 18px;
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid #000;
  }
}
nav img {
  width: auto;
  height: 28px;
  margin-left: 10px;
}
nav p {
  color: #D8D8D8;
  padding: 1%;
  font-size: 23px;
  height: 12%;
  width: 20%;
}

.ul {
  display: flex;
  float: right;
  width: 560px;
  align-items: center;
  justify-content: space-around;
  height: 12%;
  padding-top: 0;
  li {
    list-style: none;
    a {
      text-decoration: none;
      color: #666;
    }
    a:hover, a.active {
      border-bottom: 2.5px solid #000;
      color: #000;
      padding-bottom:5% ;
    }

    .el-button--small {
      font-weight: normal;
      padding: 7px 12px;
      border: 1px solid #eee;
      font-size: 15px;
    }
  }
}

</style>
<style>
* {
  margin: 0;
  padding: 0;
}
.pa {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/App.vue